<script>
import { updateMarker, updateCloneCard, hasLikes, addLike, removeLike } from '@/api/FirebaseTreesWrapper.js'
import { addCard, deleteCard } from '@/api/FirebaseBoardWrapper.js'
import { removeUrl, removeHtml, removeMention, reduceMsg, addUrlInNoMsg } from '@/api/Utilities.js'
import Store from '@/store/index.js'
import * as constant from '@/constant/constant.js'
require('@/css/style.css')

export default {
  props: [
    'nodeData',
    'treeId',
    'loginUserId', // Treeを見ているユーザーのID
    'isTeamOwner', // TeamのOwnerはTrue
    'x',
    'y',
    'w',
    'h',
    'marginX',
    'marginY',
    'maxBranchNum',
    'selector',
    'isSolved',
    'team',
    'queryNodeNum',
    'focusingTextId',
    'members',
    'graphLength',
    'isMouseDown',
    'focusedNodeNumber'
  ],
  data () {
    return {
      userId: this.nodeData.userId,
      mentionedIds: this.nodeData.mentionedIds,
      cardId: this.nodeData.cloneCardId,
      childsNum: this.nodeData.childs.length,
      color: this.nodeData.color,
      msg: '',
      showButtons: false,
      nodeClass: 'node',
      tapeClass: 'tape',
      addClass: 'is-link',
      moreClass: 'is-dark',
      paletteClass: 'is-dark',
      deleteClass: 'is-dark',
      questionUrl: '',
      isLastNodeClickFromCreated: false,
      isMarkerActive: false,
      isMenuActive: false,
      likesNumber: 0,
      isMyLikeActive: false,
      isLikesActive: false,
      touchStartTime: 0,
      isBorder: false,
      mentionedImageURL: [],
      isHover: false,
      isLeft: false,
      isNodeDown: false,
      cardLimit: constant.DEFAULT_CARD_LIMIT
    }
  },
  async created () {
    await this.renderNodes()
    this.clickFocusingNode()
  },
  watch: {
    nodeData: {
      handler: async function (val) {
        await this.renderNodes()
      },
      deep: true
    },
    selector: {
      handler: async function (val) {
        await this.renderNodes()
      },
      deep: true
    },
    queryNodeNum: function (val) {
      this.clickFocusingNode()
    },
    focusingTextId: function (val) {
      if (this.nodeData.questionId === this.focusingTextId) {
        this.clickAddButton()
      }
    },
    isMouseDown: function (val) {
      // node外でmouse upされたら取得できないのでTree.vueからisMouseDownをwatch
      if (!this.isMouseDown && this.isNodeDown) {
        this.isNodeDown = false
      }
    }
  },
  methods: {
    getUserImageUrl (uid) {
      const targetIndex = this.members.findIndex(({userId}) => userId === uid)
      if (targetIndex === -1) { return null }
      return this.members[targetIndex].imageUrl
    },
    getMentionedImageUrl (mentionedIds) {
      let array = []
      if (!mentionedIds) { return array }
      for (const uid of mentionedIds) {
        const targetIndex = this.members.findIndex(({userId}) => userId === uid)
        if (targetIndex !== -1) {
          array.push(this.members[targetIndex].imageUrl)
        }
        if (array.length >= 3) {
          break
        }
      }
      return array
    },
    async renderNodes () {
      // node初期化
      this.userId = this.nodeData.userId
      this.mentionedIds = this.nodeData.mentionedIds
      this.cardId = this.nodeData.cloneCardId
      this.childsNum = this.nodeData.childs.length
      this.color = this.nodeData.color
      this.msg = this.nodeData.question
      this.msg = removeHtml(this.msg)
      this.msg = removeUrl(this.msg)
      this.msg = removeMention(this.msg, this.mentionedIds, this.members)
      this.msg = reduceMsg(this.msg, this.cardLimit)
      this.msg = addUrlInNoMsg(this.msg)
      // ボタン系の初期化
      this.showButtons = false
      this.isMarkerActive = false
      this.isMenuActive = false
      this.isBorder = false
      this.tapeClass = 'tape'
      if (this.color === 'root') {
        this.nodeClass = 'nodeRoot'
        // RootNodeのみで初期文章の場合は編集状態からスタート
        if (this.msg === constant.DEFAULT_ROOT_MSG && this.graphLength <= 1) {
          this.$emit('clickEditQuestion', this.nodeData.questionId)
        }
      } else if (this.color === 'important') {
        this.nodeClass = 'nodeImportant'
      } else if (this.color === 'thinking') {
        this.nodeClass = 'nodeThinking'
      } else if (this.color === 'temporary') {
        this.nodeClass = 'nodeTemporary'
      } else if (this.color === 'deleted') {
        this.nodeClass = 'nodeDeleted'
      } else {
        this.nodeClass = 'node'
      }
      if (this.nodeData.questionId === this.selector.id && this.selector.group === 'nodes') {
        this.nodeClass += 'Highlight'
        this.tapeClass += 'Highlight'
        if (this.childsNum < this.maxBranchNum && this.nodeData.questionId !== 'temporaryId') {
          // maxBranch以下ならAddボタン
          this.showButtons = true
        }
      }

      // mentionの計算
      if (this.mentionedIds && this.mentionedIds.includes(this.loginUserId)) {
        this.isBorder = true
      }
      // userImageの取得
      this.questionUrl = this.getUserImageUrl(this.userId)
      // mentionURLの取得
      this.mentionedImageURL = this.getMentionedImageUrl(this.mentionedIds)
      // likesの処理
      this.isMyLikeActive = await hasLikes(this.treeId, this.nodeData.questionId)
      this.likesNumber = this.nodeData.likesNum
      this.isLikesActive = this.likesNumber > 0
    },
    onNodeUp (e) {
      // MousDown時間-MouseUp時間 = クリック時間(ms)
      const touchDeltaTime = (e.timeStamp - this.touchStartTime) / 1000.0
      if (touchDeltaTime >= 0.2) { return }
      if (this.nodeData.questionId === 'temporaryId') { return }
      if (this.focusedNodeNumber === this.nodeData.number && this.nodeData.userId === this.loginUserId) {
        // 対象nodeがすでにclick Focuseされている場合はEdit
        this.$emit('clickEditQuestion', this.nodeData.questionId)
      } else {
        // 対象nodeがFocuseされていない場合はClick
        this.clickNode(false)
      }
    },
    onNodeDown (e) {
      // MouseDown開始時間
      this.isNodeDown = true
      this.touchStartTime = e.timeStamp
    },
    onNodeMove (e) {
      const deltaTime = (e.timeStamp - this.touchStartTime) / 1000.0
      // nodeDownかつ0.05s以上の操作でDragとする
      if (this.isNodeDown && deltaTime >= 0.05) {
        this.catchNode()
      }
    },
    catchNode () {
      // drag確定
      if (!this.isTeamOwner) { return }
      this.$emit('catchNode', this.nodeData, 'node')
    },
    clickNode (isFocusingNode) {
      this.isMarkerActive = false
      this.isMenuActive = false
      const text = removeUrl(removeHtml(this.nodeData.question))
      this.$emit('clickNode', this.nodeData.questionId, this.x, this.y, isFocusingNode, text, this.nodeData.number)

      // query指定が?node=2の時のquery指定ないクリックでnode=1に遷移した場合
      // 再度通知からnode=2に遷移する再に同一pathエラーになることを回避する
      // query指定ではないクリック時にqueryがある場合は、URLをqueryなしに更新
      if (Number(this.$route.query.node) !== this.nodeData.number) {
        this.$router.push({ query: { node: this.nodeData.number, click: true } })
      }
    },
    clickAddButton () {
      if (Store.state.user.isAnonymous) {
        this.$emit('alertAnonymous', this.nodeData.questionId)
      } else {
        this.$emit('clickAddQuestion', this.nodeData.questionId, this.x, this.y)
      }
    },
    async clickCloneButton () {
      if (!this.cardId) {
        // 対象のnodeがcloneされていない場合
        try {
          const cardRef = await addCard(this.team, this.treeId, this.nodeData.questionId, this.nodeData.number, this.color, this.nodeData.question)
          await updateCloneCard(this.treeId, this.nodeData.questionId, cardRef.id)
        } catch (err) {
          console.log(err)
        }
      } else {
        // 対象のnodeがcloneされている場合
        try {
          // boardからcardを削除
          await deleteCard(this.cardId, this.team)
          // nodeのcloneCardIdもnullに戻す
          await updateCloneCard(this.treeId, this.nodeData.questionId, null)
          this.cardId = null
        } catch (err) {
          console.log(err)
        }
      }
    },
    async clickLikesButton () {
      // 匿名ユーザの処理
      if (Store.state.user.isAnonymous) {
        this.$emit('alertAnonymous', this.nodeData.questionId)
        return
      }
      if (!this.isMyLikeActive) {
        try {
          await addLike(this.treeId, this.nodeData.questionId)
          this.isMyLikeActive = !this.isMyLikeActive
          this.likesNumber += 1
          this.isLikesActive = this.likesNumber > 0
        } catch (err) {
          console.log(err)
        }
      } else {
        try {
          await removeLike(this.treeId, this.nodeData.questionId)
          this.isMyLikeActive = !this.isMyLikeActive
          this.likesNumber -= 1
          this.isLikesActive = this.likesNumber > 0
        } catch (err) {
          console.log(err)
        }
      }
    },
    clickPaletteButton () {
      // 匿名ユーザの処理
      if (Store.state.user.isAnonymous) {
        this.$emit('alertAnonymous', this.nodeData.questionId)
        return
      }
      this.isMarkerActive = !this.isMarkerActive
      this.isMenuActive = false
    },
    async clickColorButton (marker = undefined) {
      this.isMarkerActive = false
      if (marker) {
        try {
          await updateMarker(this.treeId, this.nodeData.questionId, marker)
          this.color = marker
        } catch (err) {
          // 失敗したらやり直し
          this.isMarkerActive = !this.isMarkerActive
        }
      }
    },
    clickMenuButton () {
      this.isMenuActive = !this.isMenuActive
      this.isMarkerActive = false
    },
    clickEditButton () {
      this.$emit('clickEditQuestion', this.nodeData.questionId)
      this.isMenuActive = false
    },
    clickDeleteButton () {
      this.$emit('clickDeleteQuestion', this.nodeData.questionId)
      this.isMenuActive = false
    },
    clickFocusingNode () {
      if (this.nodeData.number === this.queryNodeNum) {
        this.clickNode(true)
      }
    },
    mouseOver () {
      this.isHover = true
    },
    mouseLeave () {
      this.isHover = false
    }
  }
}
</script>
<style scoped>
.button.is-dark {
  background-color: #A9A9A9;
  border-color: transparent;
  color: whitesmoke;
}
.button.is-link {
  background-color: #96c3fa;
  border-color: transparent;
  color: #fff;
}
.button.is-danger {
  background-color: #ffaac8;
  border-color: transparent;
  color: #fff;
}
.button.is-warning {
  background-color: #fffa8c;
  border-color: transparent;
  color: #fff;
}
.button.is-success {
  background-color: #96ffc8;
  border-color: transparent;
  color: #fff;
}
.border {
  border: 2px solid #ffb4c8;
}
.node {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(60, 100%, 85%, 1) 0.5rem, hsla(60, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(60, 100%, 85%, 0.2), hsla(60, 100%, 85%, 0.2));
}
.nodeHighlight {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(50, 100%, 50%, 1) 0.5rem, hsla(60, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(60, 100%, 85%, 1), hsla(60, 100%, 85%, 1));
}
.nodeImportant {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(100, 100%, 85%, 1) 0.5rem, hsla(100, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(100, 100%, 85%, 0.2), hsla(100, 100%, 85%, 0.2));
}
.nodeImportantHighlight {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(100, 100%, 40%, 1) 0.5rem, hsla(100, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(100, 100%, 85%, 1), hsla(100, 100%, 85%, 1));
}
.nodeThinking {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.6) 0.5rem, hsla(15, 100%, 85%, 0.3) 0.75rem),
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.2), hsla(15, 100%, 85%, 0.2));
}
.nodeThinkingHighlight {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(15, 100%, 60%, 1) 0.5rem, hsla(15, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(15, 100%, 95%, 1), hsla(15, 100%, 95%, 1));
}
.nodeTemporary {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(290, 60%, 85%, 0.6) 0.5rem, hsla(290, 60%, 85%, 0.3) 0.75rem),
  linear-gradient(180deg, hsla(290, 60%, 85%, 0.2), hsla(290, 60%, 85%, 0.2));
}
.nodeTemporaryHighlight {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(290, 60%, 60%, 1) 0.5rem, hsla(290, 60%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(290, 60%, 85%, 0.2), hsla(290, 60%, 85%, 0.2));
}
.nodeDeleted {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(0, 0%, 80%, 0.6) 0.5rem, hsla(0, 0%, 80%, 0.3) 0.75rem),
  linear-gradient(180deg, hsla(0, 0%, 80%, 0.2), hsla(0, 0%, 80%, 0.2));
}
.nodeDeletedHighlight {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(0, 0%, 50%, 1) 0.5rem, hsla(0, 0%, 80%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(0, 0%, 80%, 0.2), hsla(0, 0%, 80%, 0.2));
}
.nodeRoot {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(200, 100%, 85%, 1) 0.5rem, hsla(200, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(200, 100%, 85%, 0.2), hsla(200, 100%, 85%, 0.2));
}
.nodeRootHighlight {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(200, 100%, 60%, 1) 0.5rem, hsla(200, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(200, 100%, 85%, 0.2), hsla(200, 100%, 85%, 0.2));
}
.tape {
  /* tape design */
  --jaggySize: 3px;
  --jaggyColor: rgba(51,187,255,.4);
  --tapeColor: rgba(51,187,255,.4);
  width: 35px;
  height: 20px;
  min-width: 30px;
  padding: 0px 2px;
  background:
     linear-gradient(+30deg, transparent 50%, var(--jaggyColor) 50%)
       left center / var(--jaggySize) var(--jaggySize) repeat-y,

     linear-gradient(-30deg, transparent 50%, var(--jaggyColor) 50%)
       right center /  var(--jaggySize) var(--jaggySize) repeat-y,

     linear-gradient(to left,
       transparent var(--jaggySize), var(--tapeColor) var(--jaggySize),
       var(--tapeColor) calc(100% - var(--jaggySize)), transparent calc(100% - var(--jaggySize)));

  transform: rotate(315deg);
  position: absolute;
  z-index: 1;
}
.tapeHighlight {
  /* tape design */
  --jaggySize: 3px;
  --jaggyColor: rgba(255,159,128,.9);
  --tapeColor: rgba(255,159,128,.9);
  width: 35px;
  height: 20px;
  min-width: 30px;
  padding: 0px 2px;
  background:
     linear-gradient(+30deg, transparent 50%, var(--jaggyColor) 50%)
       left center / var(--jaggySize) var(--jaggySize) repeat-y,

     linear-gradient(-30deg, transparent 50%, var(--jaggyColor) 50%)
       right center /  var(--jaggySize) var(--jaggySize) repeat-y,

     linear-gradient(to left,
       transparent var(--jaggySize), var(--tapeColor) var(--jaggySize),
       var(--tapeColor) calc(100% - var(--jaggySize)), transparent calc(100% - var(--jaggySize)));

  transform: rotate(315deg);
  position: absolute;
  z-index: 1;
}
.qNumber {
  font-size:0.7rem;
  font-weight: bold;
  color: #000000;
  position: absolute;
  z-index: 1;
}
.showButton {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: solid 1px #CCCCCC;
  background-color: #FFFFFF;
  position: absolute;
  z-index: 1;
}
.showImage {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: solid 1px #CCCCCC;
  background-color: #FFFFFF;
  position: absolute;
  z-index: 1;
}
.showMentionImage {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: solid 1px #CCCCCC;
  background-color: #FFFFFF;
  position: absolute;
  z-index: 1;
}
.speechBubble {
  text-align: center;
  color: #FFF;
  font-size:0.7rem;
  font-weight: bold;
  width: 26px;
  height: 26px;
  line-height: 26px;
  background: #a58eff;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
}
.speechBubble:before {
  content: "";
  bottom: -7px;
  left: 50%;
  margin-left: -4px;
  border: 4px solid transparent;
  border-top: 4px solid #a58eff;
  position: absolute;
  z-index: 1;
}
.button {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  position: absolute;
  z-index: 5;
}
.button.large {
  width: 30px !important;
  height: 30px !important;
}
.clone {
  box-shadow: 0 .35rem .35rem hsla(0, 0%, 0%, .5);
}
.toast {
  width: max-content;
  margin-top: 0.5rem;
  background-color: #000;
  padding: 0.2rem 0.8rem;
  border-radius: 0.5rem;
  position: absolute;
  z-index: 5;
}
.delete-toast {
  background-color: #f14668;
}
.is-size-8 {
  font-size: 0.55rem !important;
}
</style>
<template>
<div>
  <div :class="tapeClass" :style="{left:x - w/2 - marginX/2 + 'px', top:y - marginY/5 + 'px'}">
  </div>
  <!-- テープ -->
  <div class="qNumber" :style="{left:x - w/2 + 'px', top:y - 7 + 'px'}">
    <span>{{this.nodeData.number}}</span>
  </div>
  <!-- Node -->
  <div :class="[nodeClass, isBorder ? 'border' : '', nodeData.hasRef ? 'clone' : '']" :style="{left:x - w/2 + 'px', top:y + 'px', width:w - marginX + 'px', height:h - marginY + 'px'}"  v-on:mousedown="onNodeDown" v-on:mouseup="onNodeUp" v-on:mousemove="onNodeMove">
    <span>{{this.msg}}</span>
  </div>
  <!-- userアイコン -->
  <figure class="image showImage is-marginless" :style="{left:x + marginX + 'px', top:y + h/2 +  marginY/5 - 4 + 'px'}">
    <img class="is-rounded" :src="questionUrl">
  </figure>
  <!-- mentionアイコン -->
  <div v-if="mentionedIds">
    <figure v-for="(url, index) in mentionedImageURL" :key="index"
    class="image showMentionImage is-marginless" :style="{left:x -w/2 + 4 + marginX*index + 'px', top:y + h/2 + marginY/5 + 'px'}">
      <img class="is-rounded" :src="url">
    </figure>
  </div>
  <!-- addボタン -->
  <a v-if="showButtons && !isSolved" class="button large is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="addClass"  :style="{left:x - w/2 + w*2/5 - marginX/2 + 1 + 'px', top:y + h/2 + marginY/2 + 'px'}" @click="clickAddButton()">
    <span class="icon is-small"><i class="fa-solid fa-plus"></i></span>
  </a>
  <!-- cloneのToast -->
  <div class="toast has-text-white is-dark is-size-8" v-if="isHover" v-bind:class="{'delete-toast':cardId}"
  :style="{left:x - w/2 + 0.6*marginX + 'px', top:y - 0.9*marginY + 'px'}" >
    <p v-if="!cardId">クリップボードへコピー</p>
    <p v-else>クリップボードから削除</p>
  </div>
  <!-- cloneボタン -->
  <a v-if="(showButtons || cardId) && (color !== 'root') && (color !== 'deleted')" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-dark" :style="{left:x - w/2 + 0.6*marginX + 'px', top:y - marginY/5 + 'px'}"  v-bind:class="{'is-link':cardId}" @click="clickCloneButton()"
  v-on:mouseover="mouseOver()" v-on:mouseleave="mouseLeave()">
    <span class="icon is-small"><i class="fa-solid fa-paperclip" aria-hidden="true"></i></span>
  </a>
  <!-- likeボタン（押す前) -->
  <a v-if="showButtons || isLikesActive" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-dark" :style="{left:x - w/2 + 1.8*marginX + 'px', top:y - marginY/5 + 'px'}" v-bind:class="{'is-danger':isLikesActive}" @click="clickLikesButton()">
    <span class="icon is-small">
      <span class="fa-stack fa-sm">
        <i class="fa-solid fa-thumbs-up" aria-hidden="true"></i>
        <i>{{likesNumber}}</i>
      </span>
    </span>
  </a>
  <!-- colorボタン -->
  <a v-if="showButtons && (color !== 'deleted') && (color !== 'root')" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="paletteClass"  :style="{left:x - w/2 + 3.0*marginX + 'px', top:y - marginY/5 + 'px'}"  @click="clickPaletteButton()">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- colorボタン赤 -->
  <a v-if="isMarkerActive" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-danger" :style="{left:x - w/2 + 3.0*marginX + 'px', top:y - 4*marginY/5+ 'px'}"  @click="clickColorButton('thinking')">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- colorボタン黄 -->
  <a v-if="isMarkerActive" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-warning" :style="{left:x - w/2 + 4.2*marginX + 'px', top:y - 4*marginY/5 + 'px'}"  @click="clickColorButton('soso')">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- colorボタン緑 -->
  <a v-if="isMarkerActive" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless is-success" :style="{left:x - w/2 + 5.4*marginX + 'px', top:y - 4*marginY/5 + 'px'}"  @click="clickColorButton('important')">
    <span class="icon is-small"><i class="fa-solid fa-palette" aria-hidden="true"></i></span>
  </a>
  <!-- Menuボタン -->
  <a v-if="showButtons && (loginUserId === userId || isTeamOwner) && (color !== 'deleted')" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="deleteClass" :style="{left:x - w/2 + 4.2*marginX + 'px', top:y - marginY/5 + 'px'}" @click="clickMenuButton()">
    <span class="icon is-small"><i class="fa-solid fa-ellipsis-h" aria-hidden="true"></i></span>
  </a>
  <!-- 編集ボタン -->
  <a v-if="isMenuActive && (loginUserId === userId)" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="deleteClass" :style="{left:x - w/2 + 3.0*marginX + 'px', top:y - 4*marginY/5 + 'px'}" @click="clickEditButton()">
    <span class="icon is-small"><i class="fa-solid fa-pen" aria-hidden="true"></i></span>
  </a>
  <!-- 削除ボタン -->
  <a v-if="isMenuActive && (color !== 'root')" class="button is-small is-outlined is-rounded has-text-weight-bold is-paddingless" :class="deleteClass" :style="{left:x - w/2 + 4.2*marginX + 'px', top:y - 4*marginY/5 + 'px'}" @click="clickDeleteButton()">
    <span class="icon is-small"><i class="fa-solid fa-trash" aria-hidden="true"></i></span>
  </a>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/graph/GraphNode.vue